class SubscriptionSteps extends HTMLElement {
    connectedCallback() {
        this.initLine()
        this.initItems()

        gsap.registerPlugin(ScrollTrigger)
    }

    initLine() {
        const wrapper = this.querySelector('[data-line]')
        const innerLine = this.querySelector('[data-inner-line]')

        const updateLine = () => {
            const rect = wrapper.getBoundingClientRect()
            const viewportCenter = window.innerHeight / 2

            const progress = (viewportCenter - rect.top) / rect.height
            const clamped = Math.max(0, Math.min(1, progress))

            innerLine.style.height = `${clamped * 100}%`
        }

        updateLine()
        window.addEventListener('scroll', updateLine, { passive: true })
        window.addEventListener('resize', updateLine)
    }

    initItems() {
        const items = this.querySelectorAll('li[data-step-number]')

        items.forEach((item) => {

            const dot = item.querySelector('[data-dot]')
            const title = item.querySelector('[data-title]')
            const description = item.querySelector('[data-description]')

            gsap.set(dot, { color: 0.2 })
            gsap.set(title, { color: "#EBEBEB" })
            gsap.set(description, { color: "#EBEBEB" })

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: item,
                    start: 'center center',
                    toggleActions: 'play none none reverse'
                }
            })

            tl.to(dot, {
                backgroundColor: '#292929',
                duration: 0.2,
                ease: 'smooth'
            })
            tl.to(title, {
                color: "#292929",
                duration: 0.2,
                ease: 'smooth'
            }, '<')
            tl.to(description, {
                color: "#797979",
                duration: 0.2,
                ease: 'smooth'
            }, '<')
        })
    }
}

customElements.define('subscription-steps', SubscriptionSteps)